module.exports = __webpack_public_path__ + "img/item_active.ab4d02ef.svg";